<template>
    <div v-show="isModalResourceVisible">
        <transition name="slide">
            <div class="modal-mask">
                <div class="modal-dialog modal-dialog-slideout modal-lg">
                    <div class="modal-content p-2">
                        <div class="modal-header px-4 pt-2 pb-0">
                          <div class="width-100">
                            <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                            <button type="button" class="close float-right" @click="hide">
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="clearfix"></div>
                          </div>
                        </div>
                        <div class="modal-body">
                <div class="row mb-2 mt-3">
                  <div class="col-9 pl-4">
                    <div class="h3 d-inline mr-2 text-uppercase">Make a Request for Resources</div>
                    
                  </div>
                </div>                            
                            <form @submit.prevent="createNewEnterpriseAdmin" v-if="!isSuccessPanel">
                                <div class="row resource-request-row">
                                    <div class="col-12 pl-4">
                                        <label class="form-label"> What Kind of Resource Would You Like?</label>
                                        <div class="col-12 col-sm-12 resource-type-wrapper" >
                                          <div class="chkboxwrapper" v-for="(option, key, index) in resourceTypes">
                                            <input 
                                              name="resource_type"
                                              :value="option.id" 
                                              :id="option.id" 
                                              type="checkbox" 
                                              v-model="resourceType"
                                              v-validate="{ rules: { required: true }}" 
                                              >
                                            <label :for="option.name">{{ option.name }}</label>
                                          </div>
                                          
                                        </div>
                                       
                                    </div>
                                    <div v-if="verrors.firstByRule('resource_type', 'required')" class="margin-bottom-5 validate-warning-msg margin-left-15">Choose Resource</div>
                                </div>
                                <div class="row resource-request-row">
                                    <div class="col-12 pl-4">
                                       <div>
                                        <label class="form-label"> Preferred Method of Contact</label>
                                       </div> 
                                       <div>                                        
                                        <div class="padding-lr-15 resource-type-wrapper">
                                        <div class="chkboxwrapper">                                        
                                        <input type="radio" id="phone" value="Phone" v-model="contactMethod" name="contact_method" v-validate="{ rules: { required: true }}" >
                                        <label for="phone">Phone</label>
                                        </div>
                                        <div class="chkboxwrapper">                                        
                                        <input type="radio" id="email" value="Email" v-model="contactMethod" name="contact_method" v-validate="{ rules: { required: true }}" >
                                        <label for="email">Email</label>
                                        </div>
                                        <div class="chkboxwrapper">                                        
                                        <input type="radio" id="either" value="Either" v-model="contactMethod" name="contact_method" v-validate="{ rules: { required: true }}" >
                                        <label for="either">Either</label>
                                        </div>
                                        </div>                                        
                                      </div>
                                    </div>
                                    <div v-if="verrors.firstByRule('contact_method', 'required')" class="margin-bottom-5 validate-warning-msg margin-left-15">Choose Preferred Method of Contact</div>  
                                </div>
                                <div class="row resource-request-row">
                                    <div class="col-12 pl-4">
                                        <label class="form-label"> Message Title</label>
                                        <input
                                            type="text"
                                            id="title"
                                            class="col-12 col-sm-12 ma-input-field"
                                            ref="title"
                                            name="title"
                                            v-model="msgTitle"
                                            v-validate="{ rules: { required: true } }"                                            
                                            autocomplete="off">
                                        <div v-if="verrors.firstByRule('title', 'required')" class="margin-bottom-5 validate-warning-msg">Message Title is required</div>
                                       
                                    </div>
                                </div>
                                <div class="row resource-request-row">
                                    <div class="col-12 pl-4">
                                        <label class="form-label"> Message Body</label>
                                        <div>
                                          <textarea  rows="10" class="col-12 col-sm-12 message-body" v-model="msgBody" v-validate="{ rules: { required: true }}" name="body" style="resize: none;"></textarea>
                                        </div>
                                        <div v-if="verrors.firstByRule('body', 'required')" class="margin-bottom-5 validate-warning-msg">Message Body is required</div>
                                    </div>
                                </div>
                                <div class="row submit_row justify-content-md-center">
                                    <div >
                                        <button type="submit" class="btn btn-sm btn-blue saveBtn text-center">Submit</button>
                                    </div>
                                </div>
                            </form>
                            
                        </div>
                    </div>
                </div>
            </div>
        </transition>

       

    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import router from '../../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalResourceVisible'],
    data() {
        return {
            loading: false,
            isSuccessPanel: false,
            resourceType: [],
            contactMethod: '',
            msgTitle: '',
            msgBody: '',
            success_message: '',
            dismissCountDown: 0,
            resourceSelected: '',
            resourceTypes: [
                            {"name":"Task List","id":"Task List"},
                            {"name":"Course","id":"Course"},
                            {"name":"Form","id":"Form"},
                            {"name":"Assessment","id":"Assessment"}
                           ],

        }
    },    
    methods: {
        close() {
            this.verrors.clear();
            this.$emit('close');
        },
        hide () {
            this.close();
        },
        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        createNewEnterpriseAdmin() {
          this.$validator.validateAll().then((result) => {             
             if (this.verrors.items.length === 0) {
                axios("/add_new_resource_request", {
                      method: 'POST',
                      data: {
                        resource_type: this.resourceType,
                        contact_method: this.contactMethod,
                        msg_title: this.msgTitle,
                        msg_body: this.msgBody,
                      }
                    })
                    .then(response => {                        
                        this.flash({ message: response.data.msg, variant: 'success' });
                        this.$emit('close');
                        router.push("/resourses");
                        location.reload();                                            
                    })
                    .catch(error => {

                    });
           }
           });     
        }
    },
}
</script>
<style scoped>
a, a:hover {
    text-decoration: none;
}
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}

@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.saveBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 150px;
}
.closeBtn {
    color: #00acee; 
    background-color: #FFF !important;
    border: 1px solid #00acee !important;
    border-radius: 10px;
    font-weight: 900;
    width: 100%;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #000;
  background-color: #FFF;
  min-height: 30px;
  border-radius: 5px;
  border: 1px solid #CCC;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.submit_row { margin: 2rem; }
.successPanel { 
    background-color: #28a745;
    color: #FFF;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
}
.success-msg { font-size:  1.5rem; font-weight: 900;}
.success-note i { font-size: 1.25rem; margin-right: 10px; }
.gotoBtn { margin-top: 16rem; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.resource-type-wrapper .chkboxwrapper { float: left; padding: 0px 20px 0px 3px;}
.resource-request-row { margin-bottom: 15px;}
.message-body { color: #000; background-color: #FFF; border-radius: 5px; border: 1px solid #CCC;}
.back_icon { width: 14px; }

</style>
 


// WEBPACK FOOTER //
// src/components/enterpriseadmin/add_new_resourcerequest.vue